<template>
  <div class="transaction-page invisible-scrollbar">
    <section class="transaction-toolbar" :aria-label="$t('transactionRoomBooking.filters')">
      <v-menu
        v-model="menu1"
        :close-on-content-click="false"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <button
            class="transaction-date-filter"
            type="button"
            v-bind="attrs"
            v-on="on"
          >
            <span>{{ startDate || $t("transactionRoomBooking.startTime") }}</span>
            <img
              src="@/assets/figma/calendar-tick.svg"
              alt=""
              aria-hidden="true"
            />
          </button>
        </template>
        <v-date-picker
          v-model="startDate"
          @change="onFilterChange('menu1')"
        />
      </v-menu>

      <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <button
            class="transaction-date-filter"
            type="button"
            v-bind="attrs"
            v-on="on"
          >
            <span>{{ endDate || $t("transactionRoomBooking.expireTime") }}</span>
            <img
              src="@/assets/figma/calendar-tick.svg"
              alt=""
              aria-hidden="true"
            />
          </button>
        </template>
        <v-date-picker v-model="endDate" @change="onFilterChange('menu2')" />
      </v-menu>

      <v-select
        v-model="SearchStatus"
        class="transaction-status-filter"
        :items="statusItems"
        item-text="text"
        item-value="value"
        :placeholder="$t('transactionRoomBooking.status')"
        clearable
        dense
        solo
        flat
        hide-details
        @change="SearchDataTransactionRoomBooking"
      />

      <div class="transaction-search">
        <input
          v-model.trim="search"
          type="search"
          :placeholder="$t('transactionRoomBooking.search')"
          :aria-label="$t('transactionRoomBooking.searchTransaction')"
          @keydown.enter="SearchDataTransactionRoomBooking"
        />
        <button
          type="button"
          :aria-label="$t('transactionRoomBooking.search')"
          @click="SearchDataTransactionRoomBooking"
        >
          <img
            src="@/assets/figma/search-normal.svg"
            alt=""
            aria-hidden="true"
          />
        </button>
      </div>

      <button
        class="transaction-export"
        type="button"
        @click="ExportTransactionRoomBooking"
      >
        {{ $t("transactionRoomBooking.export") }}
      </button>
    </section>

    <section class="transaction-panel">
      <div class="transaction-table-scroll-hint">
        {{ $t("transactionRoomBooking.swipeHint") }}
      </div>
      <div class="transaction-table-wrap">
        <v-data-table
          class="transaction-table"
          :headers="headers"
          :items="filteredDataList"
          :items-per-page="itemsPerPage"
          item-key="id"
          hide-default-footer
          disable-sort
        >
          <template v-slot:item.no="{ index }">{{
            no_run + index + 1
          }}</template>
          <template v-slot:item.startDate="{ item }"
            ><span class="transaction-date">{{
              FormatTableDate(item.startDate)
            }}</span></template
          >
          <template v-slot:item.expireDate="{ item }"
            ><span class="transaction-date">{{
              FormatTableDate(item.expireDate)
            }}</span></template
          >
          <template v-slot:item.checkInStatus="{ item }"
            ><v-icon
              :color="item.checkInStatus ? '#149414' : '#d00000'"
              size="22"
              aria-hidden="true"
              >{{
                item.checkInStatus ? "mdi-check-circle" : "mdi-close-circle"
              }}</v-icon
            ><span class="sr-only">{{
              item.checkInStatus
                ? $t("transactionRoomBooking.checkedIn")
                : $t("transactionRoomBooking.notCheckedIn")
            }}</span
            ></template
          >
          <template v-slot:item.checkOutStatus="{ item }"
            ><v-icon
              :color="item.checkOutStatus ? '#149414' : '#d00000'"
              size="22"
              aria-hidden="true"
              >{{
                item.checkOutStatus ? "mdi-check-circle" : "mdi-close-circle"
              }}</v-icon
            ><span class="sr-only">{{
              item.checkOutStatus
                ? $t("transactionRoomBooking.checkedOut")
                : $t("transactionRoomBooking.notCheckedOut")
            }}</span
            ></template
          >
          <template v-slot:item.active="{ item }"
            ><span
              :class="['transaction-status', { inactive: !item.active }]"
              >{{
                item.active
                  ? $t("transactionRoomBooking.active")
                  : $t("transactionRoomBooking.inactive")
              }}</span
            ></template
          >
          <template v-slot:item.action="{ item }"
            ><div class="transaction-actions">
              <button
                type="button"
                :aria-label="$t('transactionRoomBooking.editTransaction')"
                @click="openTransactionRoomBookingDialog(item)"
              >
                <img
                  class="transaction-action-icon transaction-action-icon--edit"
                  src="@/assets/icons/brush.svg"
                  alt=""
                  aria-hidden="true"
                /></button
              ><button
                class="delete"
                type="button"
                :disabled="!item.active || deletingTransactionID === resolveTransactionID(item)"
                :aria-label="$t('transactionRoomBooking.deleteTransaction')"
                @click="deleteTransactionRoomBooking(item)"
              >
                <img
                  class="transaction-action-icon transaction-action-icon--delete"
                  src="@/assets/icons/bag.svg"
                  alt=""
                  aria-hidden="true"
                />
              </button>
            </div></template
          >
          <template v-slot:no-data
            ><div class="table-empty">{{ $t("transactionRoomBooking.noData") }}</div></template
          >
        </v-data-table>
      </div>

      <footer class="transaction-pagination">
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="7"
          color="#00368e"
          @input="ChangePage(page)"
        />
        <v-select
          v-model="itemsPerPage"
          class="transaction-page-size"
          :items="items"
          dense
          solo
          flat
          hide-details
          @input="ChangePerPage(itemsPerPage)"
        />
      </footer>
    </section>

    <v-dialog
      v-model="TransactionRoomBookingDialog"
      max-width="653px"
      persistent
    >
      <v-card class="transaction-edit-card">
        <header class="transaction-edit-header">
          <span>{{ $t("transactionRoomBooking.editTransaction") }}</span>
          <button
            type="button"
            :aria-label="$t('transactionRoomBooking.closeEditTransaction')"
            @click="closeTransactionRoomBookingDialog"
          >
            <v-icon color="white" size="30">mdi-close</v-icon>
          </button>
        </header>

        <div class="transaction-edit-body">
          <div class="transaction-edit-field transaction-edit-field--full">
            <label for="edit-booking-name">{{ $t("transactionRoomBooking.bookingName") }}</label>
            <v-text-field
              id="edit-booking-name"
              v-model="BookingName"
              outlined
              dense
              hide-details
            />
          </div>

          <div class="transaction-edit-grid">
            <div class="transaction-edit-field">
              <label for="edit-host-name">{{ $t("transactionRoomBooking.hostName") }}</label>
              <v-text-field
                id="edit-host-name"
                v-model="HostName"
                outlined
                dense
                hide-details
              />
            </div>
            <div class="transaction-edit-field">
              <label for="edit-facility">{{ $t("transactionRoomBooking.facility") }}</label>
              <v-select
                  id="edit-facility"
                  v-model="FacilityID"
                  :items="FacilityList"
                  item-text="facilityName"
                  item-value="facilityID"
                  outlined
                  dense
                  hide-details
                />
            </div>
            <div class="transaction-edit-field">
              <label for="edit-start-time">{{ $t("transactionRoomBooking.startTime") }}</label>
              <v-text-field
                ref="editStartTime"
                id="edit-start-time"
                v-model="EditStartTime"
                type="datetime-local"
                outlined
                dense
                hide-details
                @click="openDateTimePicker('editStartTime')"
              />
            </div>
            <div class="transaction-edit-field">
              <label for="edit-expire-time">{{ $t("transactionRoomBooking.expireTime") }}</label>
              <v-text-field
                ref="editExpireTime"
                id="edit-expire-time"
                v-model="EditExpireTime"
                type="datetime-local"
                outlined
                dense
                hide-details
                @click="openDateTimePicker('editExpireTime')"
              />
            </div>
          </div>

          <div class="transaction-edit-states">
            <div
              class="transaction-active-choice active-status-control"
              role="radiogroup"
              :aria-label="$t('transactionRoomBooking.transactionStatus')"
            >
              <button
                :class="{ selected: EditActive }"
                type="button"
                role="radio"
                :aria-checked="String(EditActive)"
                :disabled="LoadingDialog"
                @click="setTransactionActive(true)"
              >
                {{ $t("transactionRoomBooking.active") }}
              </button>
              <button
                :class="{ selected: !EditActive }"
                type="button"
                role="radio"
                :aria-checked="String(!EditActive)"
                :disabled="LoadingDialog"
                @click="setTransactionActive(false)"
              >
                {{ $t("transactionRoomBooking.inactive") }}
              </button>
            </div>
            <button
              type="button"
              class="transaction-switch transaction-switch--checkin"
              :class="{ checked: transactionCheckInStatus }"
              role="switch"
              :aria-checked="String(transactionCheckInStatus)"
              :disabled="LoadingDialog || isReactivatingTransaction"
              @click="EditCheckIn = !EditCheckIn"
            >
              <span>{{ $t("transactionRoomBooking.checkIn") }}</span><i aria-hidden="true"><b></b></i>
            </button>
            <button
              type="button"
              class="transaction-switch transaction-switch--checkout"
              :class="{ checked: EditCheckOut }"
              role="switch"
              :aria-checked="String(EditCheckOut)"
              :disabled="LoadingDialog"
              @click="toggleTransactionCheckOut"
            >
              <span>{{ $t("transactionRoomBooking.checkOut") }}</span><i aria-hidden="true"><b></b></i>
            </button>
          </div>

          <v-alert
            v-if="isReactivatingTransaction"
            class="mt-4"
            dense
            outlined
            type="info"
            role="status"
          >
            {{ $t("transactionRoomBooking.reactivationHint") }}
          </v-alert>

          <footer class="transaction-edit-actions">
            <button
              class="cancel"
              type="button"
              @click="closeTransactionRoomBookingDialog"
            >
              {{ $t("transactionRoomBooking.cancel") }}
            </button>
            <button
              class="save"
              type="button"
              :disabled="LoadingDialog"
              @click="saveTransactionRoomBooking"
            >
              {{ $t("transactionRoomBooking.save") }}
            </button>
          </footer>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >{{ $t("transactionRoomBooking.loading") }}</span
        >
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { reportPageDataUpdated } from "@/utils/pageDataUpdated";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "TransactionRoomBooking",
  components: {},
  data() {
    return {
      loader: null,
      url: enurl.apiUrl,
      LoadingDialog: false,
      loadingCount: 0,
      transactionRequestId: 0,
      items: [10, 15, 20, 50, 100],
      no_run: null,
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,

      DataList: [],
      deletingTransactionID: null,
      TowerList: [],
      menu: false,
      menu1: false,
      modal: false,
      menu2: false,

      startDate: "",
      endDate: "",
      SearchStatus: null,
      search: "",

      TransactionRoomBookingDialog: false,
      BookingName: "",
      HostName: "",
      FacilityID: null,
      DateTime: "",
      CreateTime: "",
      EditStartTime: "",
      EditExpireTime: "",
      EditActive: true,
      EditCheckIn: false,
      EditCheckOut: false,
      SelectedTransaction: null,
      FacilityList: [],
    };
  },
  computed: {
    statusItems() {
      return [
        { text: this.$t("transactionRoomBooking.active"), value: true },
        { text: this.$t("transactionRoomBooking.inactive"), value: false },
      ];
    },

    isReactivatingTransaction() {
      return Boolean(this.SelectedTransaction && !this.SelectedTransaction.active && this.EditActive);
    },

    transactionCheckInStatus() {
      if (!this.isReactivatingTransaction) return this.EditCheckIn;
      const now = Date.now();
      return new Date(this.EditStartTime).getTime() <= now
        && new Date(this.EditExpireTime).getTime() > now;
    },

    filteredDataList() {
      if (this.SearchStatus === null) return this.DataList;
      return this.DataList.filter(
        (item) => Boolean(item.active) === this.SearchStatus,
      );
    },

    headers() {
      return [
        {
          text: this.$t("transactionRoomBooking.no"),
          value: "no",
          sortable: false,
          align: "start",
        },
        {
          text: this.$t("transactionRoomBooking.bookingName"),
          value: "bookingName",
          align: "start",
          sortable: false,
        },
        {
          text: this.$t("transactionRoomBooking.hostName"),
          value: "hostName",
          align: "start",
          sortable: false,
        },
        {
          text: this.$t("transactionRoomBooking.facility"),
          value: "facilityName",
          align: "start",
          sortable: false,
        },
        {
          text: this.$t("transactionRoomBooking.startTime"),
          value: "startDate",
          align: "start",
          sortable: false,
        },
        {
          text: this.$t("transactionRoomBooking.expireTime"),
          value: "expireDate",
          align: "start",
          sortable: false,
        },
        {
          text: this.$t("transactionRoomBooking.checkIn"),
          value: "checkInStatus",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("transactionRoomBooking.checkOut"),
          value: "checkOutStatus",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("transactionRoomBooking.status"),
          value: "active",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("transactionRoomBooking.action"),
          value: "action",
          align: "center",
          sortable: false,
        },
      ];
    },
  },

  async mounted() {
    await Promise.all([
      this.getDataTransactionRoomBooking(),
      this.getDataDropdownFacility(),
    ]);
  },

  beforeDestroy() {
    this.transactionRequestId += 1;
  },

  methods: {
    startLoading() {
      this.loadingCount += 1;
      this.LoadingDialog = true;
    },

    stopLoading() {
      this.loadingCount = Math.max(0, this.loadingCount - 1);
      this.LoadingDialog = this.loadingCount > 0;
    },

    getErrorMessage(error) {
      return (
        error?.response?.data?.message ||
        error?.message ||
        this.$t("transactionRoomBooking.connectionError")
      );
    },

    onFilterChange(menuName) {
      this[menuName] = false;
      this.SearchDataTransactionRoomBooking();
    },

    showApiWarning(response, fallbackMessage) {
      Swal.fire({
        icon: "warning",
        width: 900,
        text: response?.data?.message || fallbackMessage,
      });
    },

    async getDataTransactionRoomBooking() {
      const requestId = ++this.transactionRequestId;
      const temp = {
        page: this.page,
        perpage: this.itemsPerPage,
        search: this.search,
        startDate: this.startDate,
        endDate: this.endDate,
        active: this.SearchStatus,
      };

      this.startLoading();
      try {
        const response = await axios.post(
          `${this.url}Transaction/getDataTransactionRoomBooking`,
          temp,
        );
        if (requestId !== this.transactionRequestId) return;

        if (response.data.status == 0) {
          this.DataList = response.data.data.listData || [];
          this.pageCount = response.data.data.count || 0;
          this.no_run = (this.page - 1) * this.itemsPerPage;
          reportPageDataUpdated(this);
        } else {
          this.showApiWarning(
            response,
            this.$t("transactionRoomBooking.loadFailed"),
          );
        }
      } catch (error) {
        if (requestId !== this.transactionRequestId) return;
        Swal.fire({
          icon: "error",
          title: this.$t("transactionRoomBooking.error"),
          width: 900,
          text: this.getErrorMessage(error),
        });
      } finally {
        this.stopLoading();
      }
    },

    ChangePage(value) {
      this.page = value;
      return this.getDataTransactionRoomBooking();
    },

    ChangePerPage(value) {
      this.itemsPerPage = value;
      this.page = 1;
      return this.getDataTransactionRoomBooking();
    },

    SearchDataTransactionRoomBooking() {
      if (this.startDate && this.endDate && this.endDate < this.startDate) {
        Swal.fire({
          icon: "warning",
          width: 900,
          text: this.$t("transactionRoomBooking.invalidDateRange"),
        });
        return Promise.resolve();
      }

      this.page = 1;
      return this.getDataTransactionRoomBooking();
    },

    async ExportTransactionRoomBooking() {
      if (this.startDate && this.endDate && this.endDate < this.startDate) {
        Swal.fire({
          icon: "warning",
          width: 900,
          text: this.$t("transactionRoomBooking.invalidDateRange"),
        });
        return;
      }

      const temp = {
        search: this.search,
        startDate: this.startDate,
        endDate: this.endDate,
        active: this.SearchStatus,
      };

      this.startLoading();
      try {
        const response = await axios.post(
          `${this.url}Transaction/exportTransactionRoomBooking`,
          temp,
          {
            responseType: "blob",
          },
        );

        const contentType = response.headers?.["content-type"] || "";
        if (contentType.includes("application/json")) {
          const payload = JSON.parse(await response.data.text());
          throw new Error(
            payload.message || this.$t("transactionRoomBooking.exportFailed"),
          );
        }

        const url = window.URL.createObjectURL(response.data);
        const now = new Date();
        const timestamp = [
          now.getFullYear(),
          String(now.getMonth() + 1).padStart(2, "0"),
          String(now.getDate()).padStart(2, "0"),
          "_",
          String(now.getHours()).padStart(2, "0"),
          String(now.getMinutes()).padStart(2, "0"),
          String(now.getSeconds()).padStart(2, "0"),
        ].join("");
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `TransactionRoomBooking_${timestamp}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: this.$t("transactionRoomBooking.error"),
          width: 900,
          text: this.getErrorMessage(error),
        });
      } finally {
        this.stopLoading();
      }
    },

    getDataDropdownFacility() {
      let self = this;
      return axios
        .get(`${self.url}Utility/getDataDropdownFacility`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.FacilityList = response.data.data;
            if (self.SelectedTransaction) {
              self.FacilityID = self.resolveFacilityID(
                self.SelectedTransaction,
              );
            }
          } else {
            self.showApiWarning(
              response,
              self.$t("transactionRoomBooking.facilityLoadFailed"),
            );
          }
        })
        .catch(function (error) {
          const message =
            error?.response?.data?.message ||
            error?.message ||
            self.$t("transactionRoomBooking.connectionError");

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        });
    },

    openTransactionRoomBookingDialog(data) {
      let self = this;
      self.SelectedTransaction = data;
      self.BookingName = data.bookingName;
      self.HostName = data.hostName;
      self.FacilityID = self.resolveFacilityID(data);
      self.EditStartTime = self.ToDateTimeLocal(data.startDate);
      self.EditExpireTime = self.ToDateTimeLocal(data.expireDate);
      self.EditActive = Boolean(data.active);
      self.EditCheckIn = Boolean(data.checkInStatus);
      self.EditCheckOut = Boolean(data.checkOutStatus);
      self.DateTime =
        self.ChangeFormatDate(data.startDate) +
        " - " +
        self.ChangeFormatDate(data.expireDate);
      self.CreateTime = self.ChangeFormatDate(data.createTime);
      self.TransactionRoomBookingDialog = true;
    },

    resolveFacilityID(data) {
      const selectedID = data.facilityID ?? data.facilityId;
      const selectedName = data.facility ?? data.facilityName;
      const facility = this.FacilityList.find((item) => {
        const sameID =
          selectedID != null &&
          String(item.facilityID ?? item.facilityId) === String(selectedID);
        const sameName =
          selectedName && item.facilityName === selectedName;
        return sameID || sameName;
      });

      return facility
        ? facility.facilityID ?? facility.facilityId
        : selectedID ?? null;
    },

    openDateTimePicker(refName) {
      const field = this.$refs[refName];
      const input = field?.$refs?.input;
      if (!input) return;

      if (typeof input.showPicker === "function") {
        input.showPicker();
      } else {
        input.focus();
      }
    },

    closeTransactionRoomBookingDialog() {
      this.TransactionRoomBookingDialog = false;
      this.SelectedTransaction = null;
    },

    resolveTransactionID(data) {
      return (
        data?.id ??
        data?.transactionID ??
        data?.transactionId ??
        null
      );
    },

    setTransactionActive(active) {
      this.EditActive = active;
      if (active) this.EditCheckOut = false;
    },

    toggleTransactionCheckOut() {
      this.EditCheckOut = !this.EditCheckOut;
      if (this.EditCheckOut) this.EditActive = false;
    },

    async saveTransactionRoomBooking() {
      if (!this.SelectedTransaction || this.LoadingDialog) return;
      const validationMessage = this.validateTransactionRoomBooking();
      if (validationMessage) {
        Swal.fire({
          icon: "warning",
          width: 900,
          text: validationMessage,
        });
        return;
      }

      const transactionID = this.resolveTransactionID(this.SelectedTransaction);
      if (transactionID == null || transactionID === "") {
        Swal.fire({
          icon: "warning",
          width: 900,
          text: this.$t("transactionRoomBooking.invalidTransactionId"),
        });
        return;
      }

      const temp = {
        id: transactionID,
        bookingID:
          this.SelectedTransaction.bookingID ??
          this.SelectedTransaction.bookingId,
        bookingName: this.BookingName.trim(),
        hostName: this.HostName.trim(),
        facilityID: this.FacilityID,
        startDate: this.EditStartTime,
        expireDate: this.EditExpireTime,
        active: this.EditActive,
        checkInStatus: this.transactionCheckInStatus,
        checkOutStatus: this.EditCheckOut,
      };

      this.startLoading();
      try {
        const response = await axios.post(
          `${this.url}Transaction/updateDataTransaction`,
          temp,
        );
        if (response.data.status == 0) {
          this.closeTransactionRoomBookingDialog();
          await this.getDataTransactionRoomBooking();
          Swal.fire({
            icon: "success",
            title: this.$t("transactionRoomBooking.updated"),
            text: this.$t("transactionRoomBooking.updateSuccess"),
            timer: 1500,
            showConfirmButton: false,
          });
        } else {
          Swal.fire({
            icon: "warning",
            width: 900,
            text:
              response.data.message ||
              this.$t("transactionRoomBooking.updateFailed"),
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: this.$t("transactionRoomBooking.error"),
          width: 900,
          text: this.getErrorMessage(error),
        });
      } finally {
        this.stopLoading();
      }
    },

    validateTransactionRoomBooking() {
      if (!this.BookingName?.trim())
        return this.$t("transactionRoomBooking.bookingNameRequired");
      if (!this.HostName?.trim())
        return this.$t("transactionRoomBooking.hostNameRequired");
      if (this.FacilityID == null)
        return this.$t("transactionRoomBooking.facilityRequired");
      if (!this.EditStartTime)
        return this.$t("transactionRoomBooking.startTimeRequired");
      if (!this.EditExpireTime)
        return this.$t("transactionRoomBooking.expireTimeRequired");

      const startTime = new Date(this.EditStartTime).getTime();
      const expireTime = new Date(this.EditExpireTime).getTime();
      if (!Number.isFinite(startTime) || !Number.isFinite(expireTime)) {
        return this.$t("transactionRoomBooking.invalidDateTime");
      }
      if (expireTime <= startTime) {
        return this.$t("transactionRoomBooking.expireAfterStart");
      }

      if (!this.SelectedTransaction.active && this.EditActive) {
        const now = Date.now();
        if (expireTime <= now) {
          return this.$t("transactionRoomBooking.reactivationExpired");
        }
      }

      return null;
    },

    async deleteTransactionRoomBooking(item) {
      const transactionID = this.resolveTransactionID(item);
      if (!transactionID || this.deletingTransactionID !== null) return;

      const result = await Swal.fire({
        icon: "warning",
        title: this.$t("transactionRoomBooking.deleteConfirmTitle"),
        text: this.$t("transactionRoomBooking.deleteConfirmText", {
          name:
            item.bookingName ||
            this.$t("transactionRoomBooking.thisTransaction"),
        }),
        showCancelButton: true,
        confirmButtonText: this.$t("transactionRoomBooking.delete"),
        cancelButtonText: this.$t("transactionRoomBooking.cancel"),
        confirmButtonColor: "#d00000",
      });

      if (!result.isConfirmed) return;
      const temp = {
        id: transactionID,
      };

      this.deletingTransactionID = transactionID;
      this.startLoading();
      try {
        const response = await axios.post(
          `${this.url}Transaction/deleteTransactionRoomBooking`,
          temp,
        );
        if (response.data.status == 0) {
          await this.getDataTransactionRoomBooking();
          Swal.fire({
            icon: "success",
            title: this.$t("transactionRoomBooking.deleted"),
            text:
              response.data.message ||
              this.$t("transactionRoomBooking.deleteSuccess"),
            timer: 1500,
            showConfirmButton: false,
          });
        } else {
          Swal.fire({
            icon: "warning",
            width: 900,
            text:
              response.data.message ||
              this.$t("transactionRoomBooking.deleteFailed"),
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: this.$t("transactionRoomBooking.error"),
          width: 900,
          text: this.getErrorMessage(error),
        });
      } finally {
        this.deletingTransactionID = null;
        this.stopLoading();
      }
    },

    ToDateTimeLocal(date) {
      if (!date) return "";
      const value = new Date(date);
      const offset = value.getTimezoneOffset() * 60000;
      return new Date(value.getTime() - offset).toISOString().slice(0, 16);
    },

    base64ToBlob(base64, type = "application/octet-stream") {
      const binStr = atob(base64);
      const len = binStr.length;
      const arr = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      return new Blob([arr], { type: type });
    },

    ChangeFormatDate(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },

    FormatTableDate(date) {
      return this.ChangeFormatDate(date)?.replace("  ", "\n") || "-";
    },

    GetColor(value) {
      if (value == true) {
        return "rgb(92, 184, 92,0.3)";
      } else {
        return "rgb(232, 34, 34,0.3)";
      }
    },

    GetColorText(value) {
      if (value == true) {
        return "rgb(92, 184, 92)";
      } else {
        return "rgb(232, 34, 34)";
      }
    },
  },
};
</script>
<style scoped>
.addUserTitle {
  font-size: 14px;
  font-weight: 300;
}
.input-border {
  border: 1px solid black;
  height: 35px;
  padding: 4px;
}
.validation-class {
  color: red;
  font-size: 12px;
}
.header-table-css {
  text-align: left;
  cursor: pointer;
}
.header-table-center-css {
  text-align: center;
  cursor: pointer;
}

*,
::before,
::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  background-color: #555555;
}

.transaction-edit-card {
  overflow: hidden;
  border-radius: 28px !important;
  background: #ffffff;
}

.transaction-edit-header {
  position: relative;
  display: flex;
  height: 70px;
  align-items: center;
  justify-content: center;
  background: #00378e;
  color: #ffffff;
  font-size: 21px;
  font-weight: 600;
}

.transaction-edit-header button {
  position: absolute;
  top: 17px;
  right: 22px;
  display: grid;
  width: 36px;
  height: 36px;
  place-items: center;
  border: 0;
  background: transparent;
}

.transaction-edit-body {
  padding: 32px 30px 36px;
}

.transaction-edit-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 20px;
  margin-top: 14px;
}

.transaction-edit-field label {
  display: block;
  margin: 0 0 7px 2px;
  color: #252525;
  font-size: 13px;
  font-weight: 500;
}

.transaction-edit-field ::v-deep .v-input__slot {
  min-height: 50px !important;
  border-radius: 24px !important;
  background: #ffffff !important;
}

.transaction-edit-field ::v-deep .v-text-field__slot input {
  padding-right: 8px;
  color: #282828;
  font-size: 14px;
}

.transaction-edit-field ::v-deep fieldset {
  border-color: #dddddd !important;
}

.transaction-edit-field ::v-deep .v-input--is-focused fieldset {
  border-color: #00378e !important;
}

.transaction-edit-field ::v-deep input[type="datetime-local"] {
  color: #00378e;
  caret-color: #00378e;
}

.transaction-edit-field
  ::v-deep
  input[type="datetime-local"]::-webkit-calendar-picker-indicator {
  width: 24px;
  height: 24px;
  cursor: pointer;
  background: url("~@/assets/figma/calendar-tick.svg") center / 24px 24px
    no-repeat;
  filter: none;
  opacity: 1;
}

.transaction-edit-field ::v-deep input[type="datetime-local"]::selection {
  background: rgba(0, 55, 142, 0.18);
  color: #00378e;
}

.transaction-edit-states {
  display: grid;
  grid-template-columns: 2fr 1fr 1.1fr;
  align-items: center;
  gap: 20px;
  margin-top: 24px;
}

.transaction-active-choice {
  display: flex;
  justify-content: flex-start !important;
  gap: 22px !important;
  margin-top: 0 !important;
}

.transaction-active-choice button {
  width: 108px !important;
  height: 32px !important;
  min-height: 32px !important;
  border-radius: 30px !important;
  border: 0;
  background: #ffffff;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.24);
  color: #282828;
  font-size: 12px;
}

.transaction-active-choice button.selected {
  border: 2px solid #00378e;
  color: #00378e;
  box-shadow: none;
}

.transaction-active-choice button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.transaction-active-choice button.selected:disabled {
  opacity: 1;
}

.transaction-switch {
  display: flex;
  min-height: 44px;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #252525;
  cursor: pointer;
  font-size: 13px;
  white-space: nowrap;
}

.transaction-switch:hover {
  background: #f3f6fb;
}

.transaction-switch:focus-within {
  outline: 3px solid rgba(0, 55, 142, 0.24);
  outline-offset: 2px;
}

.transaction-switch i {
  position: relative;
  display: block;
  width: 64px;
  height: 32px;
  flex: 0 0 64px;
  border-radius: 16px;
  background: #c5c9cf;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  transition: background-color 180ms ease-out;
}

.transaction-switch i b {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.24);
  transition: transform 180ms ease-out;
}

.transaction-switch.checked i b {
  transform: translateX(32px);
}

.transaction-switch--checkin.checked i {
  background: #69bf5d;
}

.transaction-switch--checkout.checked i {
  background: #df5b5b;
}

@media (prefers-reduced-motion: reduce) {
  .transaction-switch i,
  .transaction-switch i b {
    transition: none;
  }
}

.transaction-edit-actions {
  display: flex;
  justify-content: center;
  gap: 22px;
  margin-top: 48px;
}

.transaction-edit-actions button {
  width: 174px;
  height: 60px;
  border: 0;
  border-radius: 30px;
  font-size: 16px;
}

.transaction-edit-actions .cancel {
  background: #eeeeee;
  color: #00378e;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
}

.transaction-edit-actions .save {
  background: #00378e;
  color: #ffffff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.22);
}

.transaction-edit-actions button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.transaction-page {
  min-height: calc(100vh - 125px);
  padding: var(--workspace-content-top) 0 60px;
  background: #f6f6f6;
}

.transaction-toolbar {
  display: grid;
  grid-template-columns: repeat(3, minmax(180px, 335px)) minmax(280px, 472px) 157px;
  align-items: center;
  gap: 21px;
  margin-bottom: 64px;
}

.transaction-date-filter,
.transaction-export {
  height: 60px;
  border: 0;
  border-radius: 60px;
  box-shadow: 0 6px 6px rgba(0, 0, 0, 0.2);
}

.transaction-date-filter {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 0 23px 0 24px;
  background: #ffffff;
  color: #595959;
  font-size: 18px;
  text-align: left;
}

.transaction-date-filter span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.transaction-date-filter img {
  display: block;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
}

.transaction-status-filter ::v-deep .v-input__slot {
  min-height: 60px;
  padding: 0 22px !important;
  border-radius: 60px !important;
  background: #ffffff !important;
  box-shadow: 0 6px 6px rgba(0, 0, 0, 0.2) !important;
}

.transaction-status-filter ::v-deep .v-select__selection,
.transaction-status-filter ::v-deep input {
  color: #595959;
  font-size: 18px;
}

.transaction-search {
  display: flex;
  height: 60px;
  align-items: center;
  padding: 7px 8px 8px 34px;
  border-radius: 60px;
  background: #ffffff;
  box-shadow: 0 6px 6px rgba(0, 0, 0, 0.2);
}

.transaction-search input {
  min-width: 0;
  flex: 1;
  border: 0;
  outline: 0;
  color: #191c1e;
  font-size: 18px;
}

.transaction-search:focus-within,
.transaction-date-filter:focus-visible,
.transaction-export:focus-visible,
.transaction-actions button:focus-visible,
.transaction-edit-header button:focus-visible,
.transaction-active-choice button:focus-visible,
.transaction-edit-actions button:focus-visible {
  outline: 3px solid #ffb74d;
  outline-offset: 3px;
}

.transaction-search input::placeholder {
  color: #595959;
  opacity: 1;
}

.transaction-search button {
  display: grid;
  width: 45px;
  height: 45px;
  flex: 0 0 45px;
  place-items: center;
  border: 0;
  border-radius: 50%;
  background: #00378e;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

.transaction-search button img {
  display: block;
  width: 23px;
  height: 23px;
}

.transaction-export {
  background: #00378e;
  color: #ffffff;
  font-size: 20px;
  font-weight: 500;
}

.transaction-panel {
  position: relative;
  box-sizing: border-box;
  min-height: 945px;
  padding: 28px 18px 120px;
  border-radius: 30px;
  background: #ffffff;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}

.transaction-table-wrap {
  overflow-x: auto;
  border-radius: 30px 30px 0 0;
}

.transaction-table-scroll-hint {
  display: none;
}

.transaction-table {
  width: 100%;
  min-width: 1400px;
  border-collapse: collapse;
  color: #4c4c4c;
  font-size: 15px;
}
.transaction-table ::v-deep .v-data-table__wrapper {
  overflow-x: auto;
}
.transaction-table ::v-deep table {
  min-width: 1600px;
  table-layout: fixed;
}
.transaction-table ::v-deep .v-data-table-header {
  background: #00378e !important;
}
.transaction-table ::v-deep .v-data-table-header th {
  height: 81px;
  padding: 0 16px !important;
  border-bottom: 0 !important;
  color: #fff !important;
  font-size: 18px;
  font-weight: 400;
  white-space: nowrap;
}
.transaction-table ::v-deep tbody td {
  height: 65px;
  padding: 0 16px !important;
  border-bottom: 0 !important;
  color: #4c4c4c;
  font-size: 15px;
}
.transaction-table ::v-deep th:first-child,
.transaction-table ::v-deep td:first-child {
  width: 90px;
}
.transaction-table ::v-deep th:nth-child(2),
.transaction-table ::v-deep td:nth-child(2),
.transaction-table ::v-deep th:nth-child(3),
.transaction-table ::v-deep td:nth-child(3) {
  width: 160px;
}
.transaction-table ::v-deep th:nth-child(4),
.transaction-table ::v-deep td:nth-child(4) {
  width: 180px;
}
.transaction-table ::v-deep th:nth-child(5),
.transaction-table ::v-deep td:nth-child(5),
.transaction-table ::v-deep th:nth-child(6),
.transaction-table ::v-deep td:nth-child(6) {
  width: 175px;
}
.transaction-table ::v-deep th:nth-child(7),
.transaction-table ::v-deep td:nth-child(7),
.transaction-table ::v-deep th:nth-child(8),
.transaction-table ::v-deep td:nth-child(8),
.transaction-table ::v-deep th:nth-child(9),
.transaction-table ::v-deep td:nth-child(9) {
  width: 130px;
  text-align: center;
}
.transaction-table ::v-deep th:last-child,
.transaction-table ::v-deep td:last-child {
  width: 150px;
  text-align: center;
}
.transaction-table ::v-deep tbody tr {
  background: #fff;
}
.transaction-table ::v-deep tbody tr:nth-child(even) {
  background: #f6f6f6;
}
.table-empty {
  padding: 32px 16px;
  color: #595959;
  text-align: center;
}

.transaction-table thead {
  height: 81px;
  background: #00378e;
  color: #ffffff;
  font-size: 18px;
}

.transaction-table th,
.transaction-table td {
  padding: 0 16px;
  text-align: left;
}

.transaction-table th {
  font-weight: 400;
  white-space: nowrap;
}

.transaction-table th:first-child,
.transaction-table td:first-child {
  width: 90px;
  text-align: center;
}

.transaction-table th:nth-child(2) {
  width: 150px;
}
.transaction-table th:nth-child(3) {
  width: 150px;
}
.transaction-table th:nth-child(4) {
  width: 160px;
}
.transaction-table th:nth-child(5),
.transaction-table th:nth-child(6) {
  width: 155px;
}
.transaction-table th:nth-child(7),
.transaction-table th:nth-child(8) {
  width: 125px;
}
.transaction-table th:nth-child(9) {
  width: 125px;
}
.transaction-table th:last-child {
  width: 150px;
}

.transaction-table th:nth-child(n + 7),
.transaction-table td:nth-child(n + 7) {
  text-align: center;
}

.transaction-table tbody tr {
  height: 65px;
  background: #ffffff;
}

.transaction-table tbody tr:nth-child(even) {
  background: #f6f6f6;
}

.transaction-date {
  white-space: pre-line;
  line-height: 18px;
}

.transaction-status {
  display: inline-flex;
  min-width: 94px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
  background: #91d589;
  color: #3f6840;
  font-size: 15px;
}

.transaction-status.inactive {
  background: #f1aaaa;
  color: #812424;
}

.transaction-actions {
  display: flex;
  height: 65px;
  align-items: center;
  justify-content: center;
  gap: 26px;
}

.transaction-actions button {
  display: grid;
  width: 44px;
  height: 44px;
  place-items: center;
  border: 0;
  border-radius: 50%;
  background: #ff8500;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.transaction-actions button.delete {
  background: #d00000;
}

.transaction-action-icon {
  display: block;
  object-fit: contain;
}

.transaction-action-icon--edit {
  width: 18px;
  height: 18px;
}

.transaction-action-icon--delete {
  width: 24px;
  height: 24px;
}

.transaction-pagination {
  position: absolute;
  right: 18px;
  bottom: 44px;
  left: 18px;
  display: flex;
  height: 59px;
  align-items: center;
  justify-content: center;
}

.transaction-page-size {
  position: absolute;
  right: 50px;
  width: 133px;
  max-width: 133px;
}

.transaction-page-size ::v-deep .v-input__slot {
  min-height: 50px;
  border-radius: 30px !important;
  background: #f6f6f6 !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25) !important;
}

.transaction-pagination ::v-deep .v-pagination__item,
.transaction-pagination ::v-deep .v-pagination__navigation {
  width: 49px;
  min-width: 49px;
  height: 49px;
  border-radius: 10px;
}

@media (max-width: 1200px) {
  .transaction-page {
    padding-right: 24px;
    padding-left: 24px;
  }

  .transaction-toolbar {
    grid-template-columns: repeat(3, 1fr);
  }

  .transaction-search {
    grid-column: span 2;
  }
}

@media (max-width: 760px) {
  .transaction-page {
    padding: 24px 12px;
  }

  .transaction-toolbar {
    grid-template-columns: 1fr;
    gap: 14px;
    margin-bottom: 28px;
  }

  .transaction-search {
    grid-column: auto;
  }

  .transaction-export {
    width: 157px;
    justify-self: end;
  }

  .transaction-panel {
    min-height: 780px;
    padding: 12px 12px 150px;
    border-radius: 16px;
  }

  .transaction-pagination {
    bottom: 24px;
  }

  .transaction-page-size {
    right: 50%;
    bottom: -66px;
    transform: translateX(50%);
  }

  .transaction-edit-card {
    border-radius: 18px !important;
  }

  .transaction-edit-body {
    padding: 24px 18px 28px;
  }

  .transaction-edit-grid,
  .transaction-edit-states {
    grid-template-columns: 1fr;
  }

  .transaction-edit-states {
    justify-items: start;
  }

  .transaction-switch {
    justify-content: flex-start;
  }

  .transaction-edit-actions {
    gap: 12px;
    margin-top: 32px;
  }

  .transaction-edit-actions button {
    width: 50%;
  }
}

/* Compact desktop density; mobile remains unchanged. */
@media (min-width: 761px) {
  .transaction-edit-card {
    display: flex;
    height: 560px;
    flex-direction: column;
    border-radius: 16px !important;
  }

  .transaction-edit-header {
    height: 56px;
    font-size: 18px;
  }

  .transaction-edit-header button {
    top: 10px;
    right: 16px;
  }

  .transaction-edit-body {
    display: flex;
    min-height: 0;
    flex: 1;
    flex-direction: column;
    padding: 20px 24px 24px;
  }

  .transaction-edit-grid {
    gap: 8px 16px;
    margin-top: 8px;
  }

  .transaction-edit-field ::v-deep .v-input__slot {
    min-height: 46px !important;
  }

  .transaction-edit-states {
    gap: 16px;
    margin-top: 28px;
  }

  .transaction-active-choice {
    gap: 12px !important;
  }

  .transaction-edit-actions {
    gap: 16px;
    margin-top: auto;
  }

  .transaction-edit-actions button {
    width: 154px;
    height: 48px;
    border-radius: 24px;
    font-size: 15px;
  }

  .transaction-page {
    min-height: calc(100vh - 104px);
    padding: 36px 0;
  }

  .transaction-toolbar {
    grid-template-columns: repeat(3, minmax(150px, 280px)) minmax(240px, 1fr) 126px;
    gap: 14px;
    margin-bottom: 28px;
  }

  .transaction-date-filter,
  .transaction-export,
  .transaction-search {
    height: 46px;
  }

  .transaction-date-filter {
    padding: 0 17px;
    font-size: 15px;
  }

  .transaction-date-filter img {
    width: 22px;
    height: 22px;
    flex-basis: 22px;
  }

  .transaction-status-filter ::v-deep .v-input__slot {
    min-height: 46px;
    padding: 0 17px !important;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16) !important;
  }

  .transaction-status-filter ::v-deep .v-select__selection,
  .transaction-status-filter ::v-deep input,
  .transaction-search input {
    font-size: 15px;
  }

  .transaction-search {
    padding: 5px 6px 5px 22px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  }

  .transaction-search button {
    width: 36px;
    height: 36px;
    flex-basis: 36px;
    box-shadow: none;
  }

  .transaction-search button img {
    width: 18px;
    height: 18px;
  }

  .transaction-export {
    font-size: 16px;
  }

  .transaction-panel {
    min-height: 720px;
    padding: 20px 14px 94px;
    border-radius: 16px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.16);
  }

  .transaction-table-wrap {
    border-radius: 12px 12px 0 0;
  }

  .transaction-table,
  .transaction-table ::v-deep table {
    min-width: 1300px;
  }

  .transaction-table ::v-deep .v-data-table-header th {
    height: 56px;
    padding: 0 12px !important;
    font-size: 15px;
  }

  .transaction-table ::v-deep tbody td {
    height: 50px;
    padding: 0 12px !important;
    font-size: 13px;
  }

  .transaction-status {
    min-width: 78px;
    height: 26px;
    font-size: 13px;
  }

  .transaction-actions {
    height: 50px;
    gap: 16px;
  }

  .transaction-actions button {
    width: 36px;
    height: 36px;
  }

  .transaction-pagination {
    right: 14px;
    bottom: 26px;
    left: 14px;
    height: 44px;
  }

  .transaction-page-size {
    right: 30px;
    width: 112px;
  }

  .transaction-page-size ::v-deep .v-input__slot {
    min-height: 42px;
  }

  .transaction-pagination ::v-deep .v-pagination__item,
  .transaction-pagination ::v-deep .v-pagination__navigation {
    width: 40px;
    min-width: 40px;
    height: 40px;
    border-radius: 8px;
  }
}

/* Tablet-only layout; desktop keeps the original table unchanged. */
@media (min-width: 761px) and (hover: none) and (pointer: coarse) {
  .transaction-page {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    padding-right: 16px;
    padding-left: 16px;
    overflow-x: hidden;
  }

  .transaction-toolbar {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .transaction-search {
    grid-column: span 2;
  }

  .transaction-panel {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    padding-right: 14px;
    padding-left: 14px;
    overflow: hidden;
  }

  .transaction-table-scroll-hint {
    display: block;
    margin: 0 4px 10px;
    color: #52657f;
    font-size: 13px;
  }

  .transaction-table-wrap {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
  }

  .transaction-table {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100%;
  }

  .transaction-table ::v-deep table {
    width: 1200px !important;
    min-width: 1200px !important;
  }

  .transaction-table ::v-deep .v-data-table__wrapper {
    width: 100%;
    max-width: 100%;
    overflow-x: auto !important;
    overscroll-behavior-x: contain;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-x pan-y;
  }
}
</style>
